import { BrokerProduct } from '@/services/brokers/types';

export function getInsuranceType(category: BrokerProduct['category']): string {
  switch (category) {
    case 'BUSINESS_INSURANCE':
      return 'Empresarial';
    case 'GROUP_LIFE_INSURANCE':
      return 'PME - Vida em Grupo';
    case 'HOME_INSURANCE':
    default:
      return 'Residencial';
  }
}
